import { LayerTypes } from "@/types/map";
import Layer from "@/lib/map-layers/layer";
import {
  PublishedDashboard,
  MapWidgetConfigurationAllOfLayers as MapWidgetLayerConfig,
  WmsMapLayer as WmsLayerConfig,
  StaticOverlayMapLayer as StaticOverlayLayerConfig,
  PrecipitationMapLayer as PrecipitationLayerConfig,
  EdrObservationsMapLayer as EdrObservationsLayerConfig,
  SeismicEventsMapLayer as SeismicEventsLayerConfig,
} from "@/lib/api";

import WmsLayer from "./layers/wms-layer";
import StaticLayer from "./layers/static-overlay-layer";
import PrecipitationLayer from "./layers/precipitation-layer";
import EdrOberservationsLayer from "./layers/edr-observations-layer";
import SeismicEventsLayer from "./layers/seismic-events-layer";

export class MapWidgetLayerFactory {
  dashboard: PublishedDashboard;

  constructor(dashboard: PublishedDashboard) {
    this.dashboard = dashboard;
  }

  createLayer(config: MapWidgetLayerConfig) {
    let layer: Layer;
    switch (config.type) {
      case LayerTypes.WMS:
        layer = new WmsLayer(config as WmsLayerConfig, this.dashboard);
        break;
      case LayerTypes.STATIC:
        layer = new StaticLayer(config as StaticOverlayLayerConfig, this.dashboard);
        break;
      case LayerTypes.PRECIPITATION:
        layer = new PrecipitationLayer(config as PrecipitationLayerConfig, this.dashboard);
        break;
      case LayerTypes.EDR_OBSERVATIONS:
        layer = new EdrOberservationsLayer(
          config as EdrObservationsLayerConfig,
          this.dashboard,
        );
        break;
      case LayerTypes.SEISMIC_EVENTS:
        layer = new SeismicEventsLayer(config as SeismicEventsLayerConfig, this.dashboard);
        break;
      default:
        throw `unknown layer type ${config.type}`;
    }
    return layer;
  }
}
